export const EMPTY_PLACEHOLDER = '<EMPTY>';
export const ANY = '*';
export const NO_SELECTION = '';
